/* Lasclay : traitement d'image du configurateur. Vanilla JS, aucune dépendance, tout se passe dans
   le navigateur du client (rien n'est envoyé ailleurs).
   - silhouette(img)            où est le produit sur la photo studio (le fond est retiré)
   - sansLasclay(img, zone)     la même photo sans le logo Lasclay, pour la marque blanche
   - eclairage(img, sil)        plis et ombrage de la photo, reportés ensuite sur le logo
   - preparerLogo(img)          détourage du logo du client (fond uni retiré), recadrage, couleurs
   - rendre(logo, options)      rendu du logo selon la technique : broderie, étiquette tissée,
                                écusson, impression, gravure laser
   - eclairer(...)              applique l'ombrage de la photo au logo posé */
(function () {
  'use strict';
  var LI = window.LasclayImage = {};

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function lum(d, i) { return d[i] * 0.299 + d[i + 1] * 0.587 + d[i + 2] * 0.114; }
  function canevas(w, h) { var c = document.createElement('canvas'); c.width = Math.max(1, w); c.height = Math.max(1, h); return c; }
  function ctx2d(c) { return c.getContext('2d', { willReadFrequently: true }); }
  LI.canevas = canevas;

  // Pixels d'une image, réduite pour que son plus grand côté fasse au plus maxCote. Le transparent
  // devient blanc (fond studio). Lève une exception si l'image n'est pas lisible (CORS).
  function pixels(img, maxCote) {
    var nw = img.naturalWidth || img.width, nh = img.naturalHeight || img.height;
    var k = Math.min(1, maxCote / Math.max(nw, nh));
    var w = Math.max(1, Math.round(nw * k)), h = Math.max(1, Math.round(nh * k));
    var cv = canevas(w, h), cx = ctx2d(cv);
    cx.fillStyle = '#fff'; cx.fillRect(0, 0, w, h); cx.drawImage(img, 0, 0, w, h);
    return { w: w, h: h, k: k, d: cx.getImageData(0, 0, w, h).data, cv: cv, cx: cx };
  }
  LI.pixels = pixels;

  // Flou boîte séparable (bords répliqués), sur un tableau d'une valeur par pixel.
  function flou(src, w, h, r) {
    var out = new Float32Array(w * h);
    if (r < 1) { out.set(src); return out; }
    var tmp = new Float32Array(w * h), n = 2 * r + 1, x, y, s, o;
    for (y = 0; y < h; y++) {
      o = y * w; s = 0;
      for (x = -r; x <= r; x++) s += src[o + clamp(x, 0, w - 1)];
      for (x = 0; x < w; x++) { tmp[o + x] = s / n; s += src[o + Math.min(w - 1, x + r + 1)] - src[o + Math.max(0, x - r)]; }
    }
    for (x = 0; x < w; x++) {
      s = 0;
      for (y = -r; y <= r; y++) s += tmp[clamp(y, 0, h - 1) * w + x];
      for (y = 0; y < h; y++) { out[y * w + x] = s / n; s += tmp[Math.min(h - 1, y + r + 1) * w + x] - tmp[Math.max(0, y - r) * w + x]; }
    }
    return out;
  }
  LI.flou = flou;

  // Dilatation d'un masque binaire de r pixels (carré).
  function dilater(m, w, h, r) {
    var a = new Float32Array(w * h), i;
    for (i = 0; i < m.length; i++) a[i] = m[i];
    var b = flou(a, w, h, r), out = new Uint8Array(w * h);
    for (i = 0; i < m.length; i++) out[i] = b[i] > 1e-4 ? 1 : 0;
    return out;
  }

  /* ================================================================
     Silhouette du produit
     ================================================================ */
  // Le fond est ce qu'on atteint depuis les bords de la photo sans franchir d'arête nette : un fond
  // blanc ou gris pâle, même en dégradé, et les ombres douces sous le produit. Le reste est le produit.
  LI.silhouette = function (img) {
    var P;
    try { P = pixels(img, 480); } catch (e) { return null; }
    var w = P.w, h = P.h, d = P.d, n = w * h, i, x, y;
    var bord = [];
    for (x = 0; x < w; x++) { bord.push(x, (h - 1) * w + x); }
    for (y = 1; y < h - 1; y++) { bord.push(y * w, y * w + w - 1); }
    var med = [0, 1, 2].map(function (c) {
      var v = bord.map(function (j) { return d[j * 4 + c]; }).sort(function (a, b) { return a - b; });
      return v[v.length >> 1];
    });
    function procheFond(j) { var o = j * 4; return Math.abs(d[o] - med[0]) <= 48 && Math.abs(d[o + 1] - med[1]) <= 48 && Math.abs(d[o + 2] - med[2]) <= 48; }
    function pas(a, b) { var oa = a * 4, ob = b * 4; return Math.abs(d[oa] - d[ob]) <= 10 && Math.abs(d[oa + 1] - d[ob + 1]) <= 10 && Math.abs(d[oa + 2] - d[ob + 2]) <= 10; }
    var fond = new Uint8Array(n), pile = new Int32Array(n), sp = 0, nbBordFond = 0;
    bord.forEach(function (j) { if (!fond[j] && procheFond(j)) { fond[j] = 1; pile[sp++] = j; nbBordFond++; } });
    while (sp) {
      i = pile[--sp]; x = i % w; y = (i - x) / w;
      if (x > 0 && !fond[i - 1] && procheFond(i - 1) && pas(i, i - 1)) { fond[i - 1] = 1; pile[sp++] = i - 1; }
      if (x < w - 1 && !fond[i + 1] && procheFond(i + 1) && pas(i, i + 1)) { fond[i + 1] = 1; pile[sp++] = i + 1; }
      if (y > 0 && !fond[i - w] && procheFond(i - w) && pas(i, i - w)) { fond[i - w] = 1; pile[sp++] = i - w; }
      if (y < h - 1 && !fond[i + w] && procheFond(i + w) && pas(i, i + w)) { fond[i + w] = 1; pile[sp++] = i + w; }
    }
    var m = new Uint8Array(n), nb = 0, x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (i = 0; i < n; i++) {
      if (!fond[i]) {
        m[i] = 1; nb++; x = i % w; y = (i - x) / w;
        if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
      }
    }
    // Photo d'ambiance ou fond chargé : pas de silhouette fiable.
    if (nb < n * 0.03 || nb > n * 0.97 || nbBordFond < bord.length * 0.6) return null;
    var cv = canevas(w, h), cx = ctx2d(cv), id = cx.createImageData(w, h);
    for (i = 0; i < n; i++) { id.data[i * 4 + 3] = m[i] ? 255 : 0; }
    cx.putImageData(id, 0, 0);
    return { w: w, h: h, k: P.k, m: m, cv: cv, fond: med,
      boite: { x: x0 / w, y: y0 / h, w: (x1 - x0 + 1) / w, h: (y1 - y0 + 1) / h } };
  };

  function surProduit(sil, k, x, y) { // (x, y) en pixels d'une image d'échelle k par rapport à l'originale
    if (!sil) return true;
    var f = sil.k / k, sx = Math.min(sil.w - 1, (x * f) | 0), sy = Math.min(sil.h - 1, (y * f) | 0);
    return sil.m[sy * sil.w + sx] === 1;
  }

  /* ================================================================
     Marque blanche : retrait du logo Lasclay
     ================================================================ */
  // Cherche le texte du logo (traits clairs entre deux pixels sombres, comme des lettres blanches sur
  // une étiquette noire) dans la zone de recherche z (% de la photo). Retourne la boîte du texte.
  function chercherTexte(P, z, sombre, clair) {
    var W = P.w, H = P.h, d = P.d;
    var x0 = Math.max(0, Math.floor(z.x / 100 * W)), y0 = Math.max(0, Math.floor(z.y / 100 * H));
    var x1 = Math.min(W, Math.ceil((z.x + z.w) / 100 * W)), y1 = Math.min(H, Math.ceil((z.y + z.h) / 100 * H));
    var w = x1 - x0, h = y1 - y0, x, y, i, c;
    if (w < 8 || h < 8) return null;
    var Y = new Float32Array(w * h);
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) Y[y * w + x] = lum(d, ((y0 + y) * W + x0 + x) * 4);
    var K = Math.min(250, Math.max(3, Math.round(W * 0.006))), K1 = K + 1;
    var ga = new Uint8Array(w * h), dr = new Uint8Array(w * h), ha = new Uint8Array(w * h), ba = new Uint8Array(w * h);
    for (y = 0; y < h; y++) {
      c = K1; for (x = 0; x < w; x++) { i = y * w + x; c = Y[i] <= sombre ? 0 : Math.min(c + 1, K1); ga[i] = c; }
      c = K1; for (x = w - 1; x >= 0; x--) { i = y * w + x; c = Y[i] <= sombre ? 0 : Math.min(c + 1, K1); dr[i] = c; }
    }
    for (x = 0; x < w; x++) {
      c = K1; for (y = 0; y < h; y++) { i = y * w + x; c = Y[i] <= sombre ? 0 : Math.min(c + 1, K1); ha[i] = c; }
      c = K1; for (y = h - 1; y >= 0; y--) { i = y * w + x; c = Y[i] <= sombre ? 0 : Math.min(c + 1, K1); ba[i] = c; }
    }
    var trait = new Uint8Array(w * h);
    var cel = Math.max(4, Math.round(W * 0.008)), gw = Math.ceil(w / cel), gh = Math.ceil(h / cel), cnt = new Int32Array(gw * gh);
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      i = y * w + x;
      if (Y[i] >= clair && ((ga[i] <= K && dr[i] <= K) || (ha[i] <= K && ba[i] <= K))) { trait[i] = 1; cnt[((y / cel) | 0) * gw + ((x / cel) | 0)]++; }
    }
    // Regroupement : cellules actives (2 traits ou plus) reliées à deux cellules près.
    var lab = new Int32Array(gw * gh).fill(-1), pile = [], meilleur = -1, meilleurN = 0, nc = 0, j, p, q, dp, dq;
    for (j = 0; j < gw * gh; j++) {
      if (cnt[j] < 2 || lab[j] >= 0) continue;
      var tot = 0; lab[j] = nc; pile.push(j);
      while (pile.length) {
        var u = pile.pop(); tot += cnt[u]; p = (u / gw) | 0; q = u % gw;
        for (dp = -2; dp <= 2; dp++) for (dq = -2; dq <= 2; dq++) {
          var pp = p + dp, qq = q + dq;
          if (pp < 0 || qq < 0 || pp >= gh || qq >= gw) continue;
          var v = pp * gw + qq;
          if (cnt[v] >= 2 && lab[v] < 0) { lab[v] = nc; pile.push(v); }
        }
      }
      if (tot > meilleurN) { meilleurN = tot; meilleur = nc; }
      nc++;
    }
    if (meilleur < 0) return null;
    var bx0 = w, by0 = h, bx1 = -1, by1 = -1;
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      if (trait[y * w + x] && lab[((y / cel) | 0) * gw + ((x / cel) | 0)] === meilleur) {
        if (x < bx0) bx0 = x; if (x > bx1) bx1 = x; if (y < by0) by0 = y; if (y > by1) by1 = y;
      }
    }
    return { n: meilleurN, x0: bx0 + x0, y0: by0 + y0, x1: bx1 + x0 + 1, y1: by1 + y0 + 1 };
  }
  function detecterTexte(P, z) {
    var mini = Math.max(12, Math.round(P.w * 0.02));
    var t = chercherTexte(P, z, 60, 150);                      // lettres blanches sur étiquette noire
    var t2 = chercherTexte(P, z, 85, 150);                     // étiquette grise, logo sur tissu foncé
    if (t && t.n < mini) t = null;
    if (t2 && t2.n < mini) t2 = null;
    if (!t) return t2;
    // La 2e passe complète souvent un logo à peine visible (papillon gris sur nylon). Elle n'est gardée
    // que si elle couvre le même objet : sur un tricot, elle s'étend à toute la maille.
    function aire(b) { return (b.x1 - b.x0) * (b.y1 - b.y0); }
    if (t2 && t2.n > t.n && aire(t2) <= aire(t) * 4 && t2.x0 <= t.x1 && t2.x1 >= t.x0 && t2.y0 <= t.y1 && t2.y1 >= t.y0) return t2;
    return t;
  }
  LI.detecterTexte = detecterTexte;

  // Remplissage « push-pull » : les pixels inconnus prennent la moyenne lissée de leurs voisins connus,
  // de proche en proche sur une pyramide d'images. c : RVB (3 valeurs par pixel), wgt : 1 connu, 0 à remplir.
  function pushPull(c, wgt, w, h) {
    if (w <= 1 && h <= 1) return c;
    var W2 = (w + 1) >> 1, H2 = (h + 1) >> 1, cc = new Float32Array(W2 * H2 * 3), ww = new Float32Array(W2 * H2), x, y, i, j, k;
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      i = y * w + x; j = (y >> 1) * W2 + (x >> 1);
      if (!wgt[i]) continue;
      ww[j] += wgt[i]; for (k = 0; k < 3; k++) cc[j * 3 + k] += c[i * 3 + k] * wgt[i];
    }
    for (j = 0; j < W2 * H2; j++) if (ww[j] > 0) { for (k = 0; k < 3; k++) cc[j * 3 + k] /= ww[j]; ww[j] = Math.min(1, ww[j]); }
    cc = pushPull(cc, ww, W2, H2);
    var out = new Float32Array(w * h * 3);
    for (y = 0; y < h; y++) {
      var fy = clamp((y + 0.5) / 2 - 0.5, 0, H2 - 1), ya = fy | 0, yb = Math.min(H2 - 1, ya + 1), ty = fy - ya;
      for (x = 0; x < w; x++) {
        var fx = clamp((x + 0.5) / 2 - 0.5, 0, W2 - 1), xa = fx | 0, xb = Math.min(W2 - 1, xa + 1), tx = fx - xa;
        i = y * w + x;
        for (k = 0; k < 3; k++) {
          var up = (cc[(ya * W2 + xa) * 3 + k] * (1 - tx) + cc[(ya * W2 + xb) * 3 + k] * tx) * (1 - ty) +
                   (cc[(yb * W2 + xa) * 3 + k] * (1 - tx) + cc[(yb * W2 + xb) * 3 + k] * tx) * ty;
          out[i * 3 + k] = wgt[i] * c[i * 3 + k] + (1 - wgt[i]) * up;
        }
      }
    }
    return out;
  }

  // Efface le logo Lasclay des pixels P (modifiés sur place). Deux cas :
  // - étiquette sur un tissu uni et plus clair qu'elle : toute l'étiquette disparaît, remplacée par le
  //   tissu autour, avec la texture d'une zone voisine ;
  // - tissu aussi foncé que l'étiquette, logo sur un bord ou entouré d'éléments variés : seul le texte
  //   disparaît (étiquette vierge, ou tissu nu pour un logo brodé directement).
  function effacerLasclay(P, z, sil) {
    var t = detecterTexte(P, z);
    if (!t) return null;
    var W = P.w, H = P.h, d = P.d, x, y, i, k;
    var th = t.y1 - t.y0, tw = t.x1 - t.x0;
    var cap = Math.round(0.9 * Math.min(th, tw) + 0.004 * W);
    var G = { x0: Math.max(0, t.x0 - cap), y0: Math.max(0, t.y0 - cap), x1: Math.min(W, t.x1 + cap), y1: Math.min(H, t.y1 + cap) };
    var gw = G.x1 - G.x0, gh = G.y1 - G.y0, n = gw * gh;
    var Y = new Float32Array(n);
    for (y = 0; y < gh; y++) for (x = 0; x < gw; x++) Y[y * gw + x] = lum(d, ((G.y0 + y) * W + G.x0 + x) * 4);
    function dansTexte(x, y, marge) { return x >= t.x0 - G.x0 - marge && x < t.x1 - G.x0 + marge && y >= t.y0 - G.y0 - marge && y < t.y1 - G.y0 + marge; }
    function produit(x, y) { return surProduit(sil, P.k, G.x0 + x, G.y0 + y); }
    // 1. couleur du fond du texte (l'étiquette) et du tissu autour. On compare des couleurs, pas des
    //    luminosités : une étiquette noire sur un tissu rouge a presque la même luminosité que lui.
    function rgb(x, y) { var o = ((G.y0 + y) * W + G.x0 + x) * 4; return [d[o], d[o + 1], d[o + 2]]; }
    function dist(a, b) { return Math.sqrt((a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1]) + (a[2] - b[2]) * (a[2] - b[2])); }
    var dedans = [], autour = [[], [], []], nProd = 0;
    for (y = 0; y < gh; y++) for (x = 0; x < gw; x++) {
      i = y * gw + x;
      if (dansTexte(x, y, 0)) dedans.push(i);
      else if (!dansTexte(x, y, Math.round(cap * 0.6)) && produit(x, y)) { var c0 = rgb(x, y); autour[0].push(c0[0]); autour[1].push(c0[1]); autour[2].push(c0[2]); }
    }
    dedans.sort(function (p, r) { return Y[p] - Y[r]; });
    var etiq = [0, 0, 0], nE = Math.max(1, Math.round(dedans.length * 0.4));
    for (k = 0; k < nE; k++) { var ce = rgb(dedans[k] % gw, (dedans[k] / gw) | 0); etiq[0] += ce[0] / nE; etiq[1] += ce[1] / nE; etiq[2] += ce[2] / nE; }
    var tissu = autour.map(function (a) { a.sort(function (p, r) { return p - r; }); return a.length ? a[a.length >> 1] : 0; });
    var base = Y[dedans[(dedans.length * 0.25) | 0]], lumTissu = tissu[0] * 0.299 + tissu[1] * 0.587 + tissu[2] * 0.114;
    var D = dist(etiq, tissu);
    var mode = autour[0].length > 20 && D >= 40 ? 'etiquette' : 'texte';
    // l'étiquette : pixels plus proches de sa couleur que de celle du tissu, reliés au texte
    var trou = new Uint8Array(n), pile = new Int32Array(n), sp = 0, nb = 0;
    for (y = 0; y < gh; y++) for (x = 0; x < gw; x++) { i = y * gw + x; if (produit(x, y)) nProd++; if (dansTexte(x, y, 0)) { trou[i] = 1; pile[sp++] = i; nb++; } }
    while (sp && mode === 'etiquette') {
      i = pile[--sp]; x = i % gw; y = (i - x) / gw;
      [[x - 1, y], [x + 1, y], [x, y - 1], [x, y + 1]].forEach(function (v) {
        if (v[0] < 0 || v[1] < 0 || v[0] >= gw || v[1] >= gh) return;
        var j = v[1] * gw + v[0];
        if (!trou[j] && dist(rgb(v[0], v[1]), etiq) <= D * 0.5) { trou[j] = 1; pile[sp++] = j; nb++; }
      });
    }
    var d0 = Math.max(3, Math.round(W * 0.004));
    if (nb > nProd * 0.85) mode = 'texte';
    if (mode === 'etiquette') {
      trou = dilater(trou, gw, gh, d0);
      // le tour du trou doit être un tissu uni, sinon on ne garde que le texte
      // (et l'étiquette ne doit pas toucher le bord du produit : on ne saurait pas redessiner ce bord)
      var anneau = dilater(trou, gw, gh, Math.max(4, d0 * 2)), s = 0, s2 = 0, m = 0, hors = 0;
      for (i = 0; i < n; i++) if (anneau[i] && !trou[i]) { x = i % gw; y = (i - x) / gw; if (produit(x, y)) { s += Y[i]; s2 += Y[i] * Y[i]; m++; } else hors++; }
      var ecart = m ? Math.sqrt(Math.max(0, s2 / m - (s / m) * (s / m))) : 99;
      if (m < 20 || ecart > 28 || hors > (m + hors) * 0.03) mode = 'texte';
    }
    if (mode === 'texte') {
      // seulement ce qui est nettement plus clair que le fond du texte
      trou = new Uint8Array(n);
      // le tissu autour (débordant sur la boîte du texte d'une étiquette inclinée) n'est pas du texte
      var distinct = D >= 40;
      for (y = 0; y < gh; y++) for (x = 0; x < gw; x++) {
        i = y * gw + x;
        if (dansTexte(x, y, 1) && Y[i] > base + 45 && (!distinct || (Y[i] > lumTissu + 25 && dist(rgb(x, y), tissu) > 45))) trou[i] = 1;
      }
      trou = dilater(trou, gw, gh, Math.max(2, Math.round(W * 0.0025)));
    }
    // 2. zone de travail : le trou et une marge de tissu autour
    var bx0 = gw, by0 = gh, bx1 = -1, by1 = -1;
    for (i = 0; i < n; i++) if (trou[i]) { x = i % gw; y = (i - x) / gw; if (x < bx0) bx0 = x; if (x > bx1) bx1 = x; if (y < by0) by0 = y; if (y > by1) by1 = y; }
    if (bx1 < 0) return null;
    var hw = bx1 - bx0 + 1, hh = by1 - by0 + 1, marge = Math.round(Math.max(hw, hh) * 0.5) + 8;
    var C = { x0: Math.max(0, G.x0 + bx0 - marge), y0: Math.max(0, G.y0 + by0 - marge), x1: Math.min(W, G.x0 + bx1 + 1 + marge), y1: Math.min(H, G.y0 + by1 + 1 + marge) };
    var cw = C.x1 - C.x0, ch = C.y1 - C.y0, cn = cw * ch;
    var col = new Float32Array(cn * 3), wgt = new Float32Array(cn), aRemplir = new Uint8Array(cn), sR = [0, 0, 0], sL = 0, sL2 = 0, nR = 0;
    for (y = 0; y < ch; y++) for (x = 0; x < cw; x++) {
      i = y * cw + x; var o = ((C.y0 + y) * W + C.x0 + x) * 4;
      col[i * 3] = d[o]; col[i * 3 + 1] = d[o + 1]; col[i * 3 + 2] = d[o + 2];
      var gx = C.x0 + x - G.x0, gy = C.y0 + y - G.y0;
      var dansTrou = gx >= 0 && gy >= 0 && gx < gw && gy < gh && trou[gy * gw + gx];
      var prod = surProduit(sil, P.k, C.x0 + x, C.y0 + y);
      if (dansTrou && prod) aRemplir[i] = 1;
      else if (prod) {
        wgt[i] = 1;
        if (gx >= 0 && gy >= 0 && gx < gw && gy < gh) { var L = lum(d, o); sR[0] += d[o]; sR[1] += d[o + 1]; sR[2] += d[o + 2]; sL += L; sL2 += L * L; nR++; }
      }
    }
    var lisse = pushPull(col, wgt, cw, ch);
    // 3. texture : une zone voisine de même taille, sur le produit, unie et de même couleur
    var detail = null;
    if (mode === 'etiquette' && nR > 20) {
      var moy = [sR[0] / nR, sR[1] / nR, sR[2] / nR], ecR = Math.sqrt(Math.max(0, sL2 / nR - (sL / nR) * (sL / nR)));
      var ox0 = G.x0 + bx0, oy0 = G.y0 + by0, meilleur = null;
      [[-(hw + 6), 0], [hw + 6, 0], [0, -(hh + 6)], [0, hh + 6], [-(hw + 6), -(hh + 6)], [hw + 6, -(hh + 6)], [-(hw + 6), hh + 6], [hw + 6, hh + 6]].forEach(function (dv) {
        var sx = ox0 + dv[0], sy = oy0 + dv[1];
        if (sx < 0 || sy < 0 || sx + hw > W || sy + hh > H) return;
        var ok = 0, tot = 0, m3 = [0, 0, 0], l1 = 0, l2 = 0;
        for (var yy = 0; yy < hh; yy += 2) for (var xx = 0; xx < hw; xx += 2) {
          tot++; if (!surProduit(sil, P.k, sx + xx, sy + yy)) continue;
          ok++; var oo = ((sy + yy) * W + sx + xx) * 4, LL = lum(d, oo);
          m3[0] += d[oo]; m3[1] += d[oo + 1]; m3[2] += d[oo + 2]; l1 += LL; l2 += LL * LL;
        }
        if (ok < tot * 0.97) return;
        var ec = Math.sqrt(Math.max(0, l2 / ok - (l1 / ok) * (l1 / ok)));
        var diff = Math.abs(m3[0] / ok - moy[0]) + Math.abs(m3[1] / ok - moy[1]) + Math.abs(m3[2] / ok - moy[2]);
        if (ec > Math.max(6, ecR * 1.8) || diff > 45) return;
        var score = diff + 0.5 * ec;
        if (!meilleur || score < meilleur.score) meilleur = { score: score, sx: sx, sy: sy };
      });
      if (meilleur) {
        var R = 4, ex = Math.max(0, meilleur.sx - R), ey = Math.max(0, meilleur.sy - R);
        var ew = Math.min(W, meilleur.sx + hw + R) - ex, eh = Math.min(H, meilleur.sy + hh + R) - ey;
        var lim = Math.max(10, ecR * 3);
        detail = { x0: ox0, y0: oy0, w: hw, h: hh, v: new Float32Array(hw * hh * 3) };
        for (k = 0; k < 3; k++) {
          var canal = new Float32Array(ew * eh);
          for (y = 0; y < eh; y++) for (x = 0; x < ew; x++) canal[y * ew + x] = d[((ey + y) * W + ex + x) * 4 + k];
          var fl = flou(canal, ew, eh, R);
          for (y = 0; y < hh; y++) for (x = 0; x < hw; x++) {
            var e = (meilleur.sy - ey + y) * ew + (meilleur.sx - ex + x);
            detail.v[(y * hw + x) * 3 + k] = clamp(canal[e] - fl[e], -lim, lim);
          }
        }
      }
    }
    // 4. écriture
    for (y = 0; y < ch; y++) for (x = 0; x < cw; x++) {
      i = y * cw + x; if (!aRemplir[i]) continue;
      var dst = ((C.y0 + y) * W + C.x0 + x) * 4;
      for (k = 0; k < 3; k++) {
        var v2 = lisse[i * 3 + k];
        if (detail) {
          var dx = C.x0 + x - detail.x0, dy = C.y0 + y - detail.y0;
          if (dx >= 0 && dy >= 0 && dx < detail.w && dy < detail.h) v2 += detail.v[(dy * detail.w + dx) * 3 + k];
        }
        d[dst + k] = clamp(Math.round(v2), 0, 255);
      }
    }
    return { mode: mode, x0: (G.x0 + bx0) / W, y0: (G.y0 + by0) / H, x1: (G.x0 + bx1 + 1) / W, y1: (G.y0 + by1 + 1) / H };
  }
  LI.effacerLasclay = effacerLasclay;

  // Photo sans le logo Lasclay : promesse d'une URL locale (blob), ou null si rien n'a été trouvé.
  LI.sansLasclay = function (img, z, sil) {
    return new Promise(function (ok) {
      if (!z || !(z.w > 0) || !(z.h > 0)) return ok(null);
      var P;
      try { P = pixels(img, 2400); } catch (e) { return ok(null); }
      var r = effacerLasclay(P, z, sil);
      if (!r) return ok(null);
      var id = P.cx.createImageData(P.w, P.h); id.data.set(P.d); P.cx.putImageData(id, 0, 0);
      try { P.cv.toBlob(function (b) { ok(b ? { url: URL.createObjectURL(b), zone: r } : null); }, 'image/jpeg', 0.92); } catch (e) { ok(null); }
    });
  };

  /* ================================================================
     Éclairage de la photo
     ================================================================ */
  // plis : ombrage à grande échelle (plis, rondeurs, ombres), sans le grain du tissu ;
  // fin : le même, avec le grain du tissu, pour une encre qui épouse la toile.
  // Moyennes calculées sur le produit seulement, pour que le fond blanc n'assombrisse pas les bords.
  LI.eclairage = function (img, sil) {
    var P;
    try { P = pixels(img, 600); } catch (e) { return null; }
    var w = P.w, h = P.h, n = w * h, d = P.d, i, x, y;
    var Y = new Float32Array(n), M = new Float32Array(n), YM = new Float32Array(n);
    for (i = 0; i < n; i++) {
      x = i % w; y = (i - x) / w;
      Y[i] = lum(d, i * 4); M[i] = surProduit(sil, P.k, x, y) ? 1 : 0; YM[i] = Y[i] * M[i];
    }
    var rL = Math.max(4, Math.round(w * 0.05));
    var bL = flou(YM, w, h, rL), mL = flou(M, w, h, rL), b1 = flou(Y, w, h, 1);
    var plis = new Float32Array(n), fin = new Float32Array(n);
    for (i = 0; i < n; i++) {
      var ref = mL[i] > 0.05 ? bL[i] / mL[i] : Y[i];
      plis[i] = clamp((b1[i] + 10) / (ref + 10), 0.55, 1.3);
      fin[i] = clamp((Y[i] + 10) / (ref + 10), 0.5, 1.35);
    }
    return { w: w, h: h, k: P.k, d: d, plis: plis, fin: fin, m: M };
  };
  // Couleur du produit autour d'un point (fractions de la photo) : médiane des pixels du produit.
  LI.couleurSous = function (ecl, fx, fy, fr) {
    if (!ecl) return [128, 128, 128];
    var w = ecl.w, h = ecl.h, cx = fx * w, cy = fy * h, r = Math.max(2, fr * w), v = [[], [], []];
    for (var y = Math.max(0, Math.floor(cy - r)); y < Math.min(h, cy + r); y += 2) {
      for (var x = Math.max(0, Math.floor(cx - r)); x < Math.min(w, cx + r); x += 2) {
        var i = y * w + x; if (!ecl.m[i]) continue;
        v[0].push(ecl.d[i * 4]); v[1].push(ecl.d[i * 4 + 1]); v[2].push(ecl.d[i * 4 + 2]);
      }
    }
    if (!v[0].length) return [128, 128, 128];
    return v.map(function (a) { a.sort(function (p, q) { return p - q; }); return a[a.length >> 1]; });
  };

  /* ================================================================
     Logo du client : détourage et couleurs
     ================================================================ */
  // Fond uni (blanc derrière un logo noir, par exemple) : il est retiré, y compris dans les
  // contre-formes des lettres, et les bords sont adoucis sans halo. Un logo déjà transparent est gardé
  // tel quel. Retourne les deux versions (avec et sans fond), recadrées sur le logo.
  LI.preparerLogo = function (img) {
    var nw = img.naturalWidth || img.width || 1000, nh = img.naturalHeight || img.height || 1000;
    var k = Math.min(1, 1200 / Math.max(nw, nh)), w = Math.max(1, Math.round(nw * k)), h = Math.max(1, Math.round(nh * k));
    var cv = canevas(w, h), cx = ctx2d(cv);
    cx.drawImage(img, 0, 0, w, h);
    var id = cx.getImageData(0, 0, w, h), d = id.data, n = w * h, i, x, y;
    var bord = [];
    for (x = 0; x < w; x += 2) { bord.push(x, (h - 1) * w + x); }
    for (y = 0; y < h; y += 2) { bord.push(y * w, y * w + w - 1); }
    var transp = 0;
    bord.forEach(function (j) { if (d[j * 4 + 3] < 250) transp++; });
    var fond = null;
    if (transp < bord.length * 0.3) {
      // couleur dominante du pourtour
      var seaux = {}, top = null;
      bord.forEach(function (j) {
        var o = j * 4, cle = (d[o] >> 4) + ',' + (d[o + 1] >> 4) + ',' + (d[o + 2] >> 4);
        var s = seaux[cle] || (seaux[cle] = { n: 0, r: 0, g: 0, b: 0 });
        s.n++; s.r += d[o]; s.g += d[o + 1]; s.b += d[o + 2];
        if (!top || s.n > top.n) top = s;
      });
      var proches = 0, ref = [top.r / top.n, top.g / top.n, top.b / top.n];
      bord.forEach(function (j) { var o = j * 4; if (Math.max(Math.abs(d[o] - ref[0]), Math.abs(d[o + 1] - ref[1]), Math.abs(d[o + 2] - ref[2])) <= 40) proches++; });
      if (proches >= bord.length * 0.85) fond = ref;
    }
    var sans = new Uint8ClampedArray(d);
    if (fond) {
      for (i = 0; i < n; i++) {
        var o = i * 4;
        var dist = Math.max(Math.abs(d[o] - fond[0]), Math.abs(d[o + 1] - fond[1]), Math.abs(d[o + 2] - fond[2]));
        var a = clamp((dist - 18) / 52, 0, 1) * (d[o + 3] / 255);
        if (a < 1 && a > 0) { // décontamination : on retire la part du fond mêlée au bord
          for (var c = 0; c < 3; c++) sans[o + c] = clamp(Math.round((d[o + c] - (1 - a) * fond[c]) / a), 0, 255);
        }
        sans[o + 3] = Math.round(a * 255);
      }
    }
    function recadrer(data) {
      var x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (y = 0; y < h; y++) for (x = 0; x < w; x++) if (data[(y * w + x) * 4 + 3] > 10) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      if (x1 < 0) { x0 = 0; y0 = 0; x1 = w - 1; y1 = h - 1; }
      var cw = x1 - x0 + 1, ch = y1 - y0 + 1, out = canevas(cw, ch), oc = ctx2d(out), oid = oc.createImageData(cw, ch);
      for (y = 0; y < ch; y++) oid.data.set(data.subarray(((y0 + y) * w + x0) * 4, ((y0 + y) * w + x0 + cw) * 4), y * cw * 4);
      oc.putImageData(oid, 0, 0);
      return out;
    }
    var vSans = recadrer(sans), vAvec = recadrer(d);
    return { sans: decrire(vSans), avec: decrire(vAvec), fondRetire: !!fond, fond: fond };
  };
  // Couleurs principales (6 au plus), luminance moyenne.
  function decrire(cv) {
    var w = cv.width, h = cv.height, d = ctx2d(cv).getImageData(0, 0, w, h).data, n = w * h, i, o;
    var pas = Math.max(1, Math.floor(Math.sqrt(n / 40000))), seaux = {}, liste = [], total = 0, L = 0;
    for (var y = 0; y < h; y += pas) for (var x = 0; x < w; x += pas) {
      o = (y * w + x) * 4; if (d[o + 3] < 160) continue;
      var cle = (d[o] >> 3) + ',' + (d[o + 1] >> 3) + ',' + (d[o + 2] >> 3);
      var s = seaux[cle]; if (!s) { s = seaux[cle] = { n: 0, c: [d[o], d[o + 1], d[o + 2]] }; liste.push(s); }
      s.n++; total++; L += lum(d, o);
    }
    liste.sort(function (a, b) { return b.n - a.n; });
    var centres = [];
    liste.forEach(function (s) {
      if (centres.length >= 6 || s.n < total * 0.02) return;
      for (var j = 0; j < centres.length; j++) {
        var c = centres[j];
        if (Math.max(Math.abs(c[0] - s.c[0]), Math.abs(c[1] - s.c[1]), Math.abs(c[2] - s.c[2])) < 56) return;
      }
      centres.push(s.c.slice());
    });
    if (!centres.length) centres.push([30, 30, 30]);
    // centres affinés : moyenne des pixels les plus proches
    var som = centres.map(function () { return [0, 0, 0, 0]; });
    for (i = 0; i < n; i += pas) {
      o = i * 4; if (d[o + 3] < 160) continue;
      var b = 0, bd = 1e9;
      for (var j2 = 0; j2 < centres.length; j2++) { var c2 = centres[j2], dd = (c2[0] - d[o]) * (c2[0] - d[o]) + (c2[1] - d[o + 1]) * (c2[1] - d[o + 1]) + (c2[2] - d[o + 2]) * (c2[2] - d[o + 2]); if (dd < bd) { bd = dd; b = j2; } }
      som[b][0] += d[o]; som[b][1] += d[o + 1]; som[b][2] += d[o + 2]; som[b][3]++;
    }
    var palette = centres.map(function (c, j) { var s = som[j]; return s[3] ? [s[0] / s[3], s[1] / s[3], s[2] / s[3]] : c; });
    return { cv: cv, w: w, h: h, ratio: w / h, palette: palette, lum: total ? L / total : 128 };
  }

  /* ================================================================
     Rendu du logo selon la technique
     ================================================================ */
  // Dimensions de l'objet posé (le cadre qu'on manipule) pour un logo de largeur lw et de rapport r :
  // le logo seul, ou l'étiquette, ou l'écusson qui l'entoure.
  LI.geometrie = function (technique, lw, r) {
    var lh = lw / r, pad = 0;
    if (technique === 'etiquette') pad = Math.max(lh * 0.24, lw * 0.07);
    else if (technique === 'ecusson') pad = Math.max(lh * 0.3, lw * 0.1);
    return { lw: lw, lh: lh, pad: pad, ow: lw + 2 * pad, oh: lh + 2 * pad };
  };

  function hash(a, b) { var s = Math.sin(a * 127.1 + b * 311.7) * 43758.5453; return s - Math.floor(s); }
  var BLANC = [244, 242, 236], NOIR = [26, 26, 26];

  // Couleur de chaque pixel ramenée aux couleurs de fil (broderie, tissage) ; index de la couleur.
  function fils(L, n, palette) {
    var idx = new Uint8Array(n);
    for (var i = 0; i < n; i++) {
      var o = i * 4, b = 0, bd = 1e9;
      for (var j = 0; j < palette.length; j++) { var c = palette[j], dd = (c[0] - L[o]) * (c[0] - L[o]) + (c[1] - L[o + 1]) * (c[1] - L[o + 1]) + (c[2] - L[o + 2]) * (c[2] - L[o + 2]); if (dd < bd) { bd = dd; b = j; } }
      idx[i] = b;
    }
    return idx;
  }

  // Broderie : points lancés en diagonale (sens alterné d'une couleur à l'autre), rangs décalés comme
  // un remplissage tatami, fil satiné qui accroche la lumière, bords irréguliers, relief et ombre portée.
  function broder(out, ow, oh, ox, oy, L, lw, lh, A, palette, pt) {
    var n = lw * lh, idx = fils(L, n, palette), i, x, y;
    var angles = [45, -45, 30, -30, 60, -60];
    // bords : les points dépassent ou s'arrêtent un peu avant le contour
    var A2 = new Float32Array(n);
    for (y = 0; y < lh; y++) for (x = 0; x < lw; x++) {
      i = y * lw + x; var a = A[i];
      var th = angles[idx[i] % 6] * Math.PI / 180, t = (x * Math.cos(th) + y * Math.sin(th)) / pt;
      var bord = 1 - Math.abs(2 * a - 1);
      a = a + (hash(Math.floor(t), idx[i]) - 0.5) * 0.5 * bord;
      A2[i] = clamp((a - 0.35) / 0.3, 0, 1);
    }
    var Hm = flou(flou(A2, lw, lh, Math.max(1, Math.round(pt * 0.6))), lw, lh, Math.max(1, Math.round(pt * 0.4)));
    var ombre = flou(A2, lw, lh, Math.max(1, Math.round(pt * 0.7)));
    var sx = Math.round(pt * 0.35), sy = Math.round(pt * 0.6);
    for (y = 0; y < lh; y++) for (x = 0; x < lw; x++) {
      i = y * lw + x;
      var X = x + ox, Yy = y + oy, o = (Yy * ow + X) * 4;
      // ombre portée sous le fil
      var ys = y - sy, xs = x - sx;
      if (ys >= 0 && xs >= 0) {
        var so = ombre[ys * lw + xs] * 0.45;
        if (so > 0.01) { var o2 = o; out[o2 + 3] = Math.max(out[o2 + 3], so * 255); }
      }
    }
    for (y = 0; y < lh; y++) for (x = 0; x < lw; x++) {
      i = y * lw + x; var a = A2[i];
      if (a <= 0.01) continue;
      var c = palette[idx[i]], th = angles[idx[i] % 6] * Math.PI / 180;
      var t = (x * Math.cos(th) + y * Math.sin(th)) / pt, f = t - Math.floor(t);
      var arete = Math.sin(Math.PI * f);
      var u = (-x * Math.sin(th) + y * Math.cos(th)) / (pt * 5) + 0.37 * Math.floor(t), fu = u - Math.floor(u);
      var coupe = fu < 0.07 ? 0.82 : 1;
      var varie = 0.95 + 0.1 * hash(Math.floor(t), Math.floor(u));
      var gx = Hm[y * lw + Math.min(lw - 1, x + 1)] - Hm[y * lw + Math.max(0, x - 1)];
      var gy = Hm[Math.min(lh - 1, y + 1) * lw + x] - Hm[Math.max(0, y - 1) * lw + x];
      var lambert = clamp(1 + 1.26 * (gx + gy), 0.62, 1.35);   // lumière en haut à gauche
      var fil = (0.7 + 0.42 * Math.pow(arete, 0.7)) * coupe * varie * lambert;
      var brillance = Math.max(0, arete - 0.78) * 0.9 * lambert;
      var o = ((y + oy) * ow + x + ox) * 4, pa = out[o + 3] / 255;
      var r = clamp(c[0] * fil + 255 * brillance * 0.35, 0, 255), g = clamp(c[1] * fil + 255 * brillance * 0.35, 0, 255), b = clamp(c[2] * fil + 255 * brillance * 0.35, 0, 255);
      // fil par-dessus l'ombre déjà posée (ombre noire)
      var na = a + pa * (1 - a);
      out[o] = (r * a + out[o] * pa * (1 - a)) / na; out[o + 1] = (g * a + out[o + 1] * pa * (1 - a)) / na; out[o + 2] = (b * a + out[o + 2] * pa * (1 - a)) / na;
      out[o + 3] = na * 255;
    }
  }

  // Distance signée au bord d'un rectangle arrondi (négative dedans), en pixels.
  function sdfRect(x, y, w, h, r) {
    var qx = Math.abs(x - w / 2) - (w / 2 - r), qy = Math.abs(y - h / 2) - (h / 2 - r);
    return Math.min(Math.max(qx, qy), 0) + Math.sqrt(Math.max(qx, 0) * Math.max(qx, 0) + Math.max(qy, 0) * Math.max(qy, 0)) - r;
  }

  // Rendu complet. o : { technique, teinte ('originale', 'blanc', 'noir'), largeur (px du logo),
  // point (px par point de fil), sous ([r, g, b] du produit sous le logo) }.
  // Retourne { cv, x, y, w, h } : (x, y, w, h) = l'objet dans cv, sans l'ombre portée.
  LI.rendre = function (logo, o) {
    var tech = o.technique || 'impression', pt = Math.max(1.6, o.point || 3);
    var G = LI.geometrie(tech, Math.max(4, o.largeur), logo.ratio);
    var lw = Math.max(2, Math.round(G.lw)), lh = Math.max(2, Math.round(G.lh)), pad = Math.round(G.pad);
    var ow0 = lw + 2 * pad, oh0 = lh + 2 * pad, m = Math.ceil(pt * 2.5) + 2;
    var ow = ow0 + 2 * m, oh = oh0 + 2 * m, out = new Float32Array(ow * oh * 4), x, y, i, o2;
    // logo à la taille voulue
    var lc = canevas(lw, lh), lx = ctx2d(lc);
    lx.imageSmoothingQuality = 'high'; lx.drawImage(logo.cv, 0, 0, lw, lh);
    var L = lx.getImageData(0, 0, lw, lh).data, n = lw * lh, A = new Float32Array(n);
    for (i = 0; i < n; i++) A[i] = L[i * 4 + 3] / 255;
    var palette = logo.palette;
    if (o.teinte === 'blanc' || o.teinte === 'noir') {
      var t = o.teinte === 'blanc' ? BLANC : NOIR;
      for (i = 0; i < n; i++) { L[i * 4] = t[0]; L[i * 4 + 1] = t[1]; L[i * 4 + 2] = t[2]; }
      palette = [t];
    }
    var lumLogo = o.teinte === 'blanc' ? 240 : o.teinte === 'noir' ? 26 : logo.lum;
    var sous = o.sous || [128, 128, 128], lumSous = sous[0] * 0.299 + sous[1] * 0.587 + sous[2] * 0.114;
    var ox = m + pad, oy = m + pad;

    if (tech === 'broderie') {
      broder(out, ow, oh, ox, oy, L, lw, lh, A, palette, pt);
    } else if (tech === 'etiquette' || tech === 'ecusson') {
      var ecu = tech === 'ecusson';
      // fond de l'étiquette : clair sous un logo foncé, noir sous un logo clair
      var fondE = lumLogo < 110 ? (ecu ? [236, 229, 214] : [242, 239, 231]) : (ecu ? [38, 42, 48] : [24, 24, 24]);
      var rayon = ecu ? Math.min(ow0, oh0) * 0.22 : Math.max(1, pt * 0.4), bordure = ecu ? pt * 2.2 : 0;
      var bordC = ecu ? (lumLogo < 110 ? palette[0] : [200, 196, 188]) : null;
      var Hm = new Float32Array(ow0 * oh0);
      for (y = 0; y < oh0; y++) for (x = 0; x < ow0; x++) Hm[y * ow0 + x] = clamp(-sdfRect(x + 0.5, y + 0.5, ow0, oh0, rayon) / (pt * 1.5), 0, 1);
      var ombreE = flou(Hm, ow0, oh0, Math.max(1, Math.round(pt * (ecu ? 1.2 : 0.8))));
      var dsx = Math.round(pt * (ecu ? 0.6 : 0.3)), dsy = Math.round(pt * (ecu ? 0.9 : 0.5));
      for (y = 0; y < oh0; y++) for (x = 0; x < ow0; x++) {
        var a0 = ombreE[y * ow0 + x] * (ecu ? 0.5 : 0.38);
        o2 = ((y + m + dsy) * ow + x + m + dsx) * 4;
        if (y + m + dsy < oh && x + m + dsx < ow) out[o2 + 3] = Math.max(out[o2 + 3], a0 * 255);
      }
      for (y = 0; y < oh0; y++) for (x = 0; x < ow0; x++) {
        var sd = sdfRect(x + 0.5, y + 0.5, ow0, oh0, rayon), a1 = clamp(0.5 - sd, 0, 1);
        if (a1 <= 0) continue;
        var tex, c3 = fondE;
        if (ecu) {
          tex = 0.93 + 0.07 * Math.cos(2 * Math.PI * (x + y) / (pt * 0.9));                 // sergé
          if (-sd < bordure) {                                                               // bord surjeté
            var ang = Math.atan2(y - oh0 / 2, x - ow0 / 2) * (ow0 + oh0) / (pt * 0.55);
            tex = 0.72 + 0.4 * Math.sin(Math.PI * (ang - Math.floor(ang))); c3 = bordC;
          }
        } else {
          tex = 0.93 + 0.05 * Math.cos(2 * Math.PI * y / (pt * 0.55)) + 0.03 * Math.cos(2 * Math.PI * x / (pt * 1.1));
          var bout = Math.min(x, ow0 - 1 - x);                                               // bouts repliés
          if (bout < pt * 1.6) tex *= 0.84 + 0.16 * bout / (pt * 1.6);
          if (Math.abs(bout - pt * 2.6) < pt * 0.22 && Math.floor(y / (pt * 0.9)) % 2 === 0) { c3 = lumLogo < 110 ? [150, 146, 138] : [96, 96, 96]; } // couture
        }
        var gx2 = (x + 1 < ow0 ? Hm[y * ow0 + x + 1] : 0) - (x > 0 ? Hm[y * ow0 + x - 1] : 0);
        var gy2 = (y + 1 < oh0 ? Hm[(y + 1) * ow0 + x] : 0) - (y > 0 ? Hm[(y - 1) * ow0 + x] : 0);
        var lam = clamp(1 + 0.98 * (gx2 + gy2), 0.7, 1.25);
        o2 = ((y + m) * ow + x + m) * 4;
        var pa = out[o2 + 3] / 255, na = a1 + pa * (1 - a1);
        for (var k = 0; k < 3; k++) out[o2 + k] = (c3[k] * tex * lam * a1 + out[o2 + k] * pa * (1 - a1)) / na;
        out[o2 + 3] = na * 255;
      }
      if (ecu) broder(out, ow, oh, ox, oy, L, lw, lh, A, palette, pt);
      else {
        // logo tissé : fils fins horizontaux, couleurs de fil, bords nets
        var idx = fils(L, n, palette);
        for (y = 0; y < lh; y++) for (x = 0; x < lw; x++) {
          i = y * lw + x; var a2 = clamp((A[i] - 0.3) / 0.4, 0, 1); if (a2 <= 0) continue;
          var c4 = palette[idx[i]], f2 = (y / (pt * 0.5)) % 1;
          var tx2 = 0.82 + 0.26 * Math.sin(Math.PI * f2);
          o2 = ((y + oy) * ow + x + ox) * 4;
          for (var k2 = 0; k2 < 3; k2++) out[o2 + k2] = out[o2 + k2] * (1 - a2) + c4[k2] * tx2 * a2;
        }
      }
    } else if (tech === 'gravure') {
      // brûlure du bois : brun foncé, plus sombre sur les bords du tracé ; posé en « produit » (multiply)
      var B = flou(A, lw, lh, Math.max(1, Math.round(pt * 0.5)));
      for (y = 0; y < lh; y++) for (x = 0; x < lw; x++) {
        i = y * lw + x; var a3 = A[i]; if (a3 <= 0.02) continue;
        var bordG = clamp(1 - B[i], 0, 1), grain = 0.92 + 0.16 * hash(x >> 1, y >> 1);
        o2 = ((y + oy) * ow + x + ox) * 4;
        out[o2] = (96 - 40 * bordG) * grain; out[o2 + 1] = (60 - 28 * bordG) * grain; out[o2 + 2] = (36 - 18 * bordG) * grain;
        out[o2 + 3] = a3 * 235;
      }
    } else {
      // impression : encre à plat, légère irrégularité ; le grain du tissu est ajouté par eclairer()
      for (y = 0; y < lh; y++) for (x = 0; x < lw; x++) {
        i = y * lw + x; var a4 = A[i]; if (a4 <= 0) continue;
        var bruit = 0.97 + 0.06 * hash(x, y);
        o2 = ((y + oy) * ow + x + ox) * 4;
        out[o2] = L[i * 4] * bruit; out[o2 + 1] = L[i * 4 + 1] * bruit; out[o2 + 2] = L[i * 4 + 2] * bruit; out[o2 + 3] = a4 * 238;
      }
    }
    var cv = canevas(ow, oh), cx = ctx2d(cv), id = cx.createImageData(ow, oh);
    for (i = 0; i < ow * oh * 4; i++) id.data[i] = out[i];
    cx.putImageData(id, 0, 0);
    return { cv: cv, x: m, y: m, w: ow0, h: oh0, lumLogo: lumLogo, lumSous: lumSous };
  };

  // Reporte l'ombrage de la photo (plis, rondeurs) sur la zone (x, y, w, h) du canevas cx, dont le
  // pixel (px, py) correspond au point (px - ix) / iw, (py - iy) / ih de la photo. fin : avec le grain.
  LI.eclairer = function (cx, ecl, x, y, w, h, ix, iy, iw, ih, fin) {
    if (!ecl || w < 1 || h < 1) return;
    x = Math.max(0, Math.floor(x)); y = Math.max(0, Math.floor(y));
    w = Math.min(cx.canvas.width - x, Math.ceil(w)); h = Math.min(cx.canvas.height - y, Math.ceil(h));
    if (w < 1 || h < 1) return;
    var id = cx.getImageData(x, y, w, h), d = id.data, carte = fin ? ecl.fin : ecl.plis, g = fin ? 1 : 0.9;
    for (var j = 0; j < h; j++) {
      var fy = ((y + j) - iy) / ih * ecl.h; if (fy < 0 || fy >= ecl.h) continue;
      var ya = Math.min(ecl.h - 1, fy | 0);
      for (var i2 = 0; i2 < w; i2++) {
        var o = (j * w + i2) * 4; if (!d[o + 3]) continue;
        var fx = ((x + i2) - ix) / iw * ecl.w; if (fx < 0 || fx >= ecl.w) continue;
        var s = Math.pow(carte[ya * ecl.w + Math.min(ecl.w - 1, fx | 0)], g);
        d[o] = d[o] * s; d[o + 1] = d[o + 1] * s; d[o + 2] = d[o + 2] * s;
      }
    }
    cx.putImageData(id, x, y);
  };
})();
